/* istanbul ignore file */
import React from 'react';
import { useApplicationSettings, useUiTheme } from 'framework/uiTheme';
import { FieldLayoutProps } from 'framework/ui/field';
import { useAsyncValue } from 'framework/utils';
import HtmlWithArtifactFieldDecorator from './HtmlWithArtifactFieldDecorator';

const HtmlFieldLayoutWithTags = ({ value, label }: FieldLayoutProps) => {
  const { BaseFieldLayout } = useUiTheme();
  const { useDefaultTextTransformer } = useApplicationSettings();
  const { mapAsyncTags = () => {}, mapTags = () => {} } = useDefaultTextTransformer?.() ?? {};
  const syncData = mapTags(value);
  const mappedTags = useAsyncValue(async () => mapAsyncTags(syncData), [syncData]);
  const field = <BaseFieldLayout label={label} value={mappedTags || syncData} />;

  return <HtmlWithArtifactFieldDecorator>{field}</HtmlWithArtifactFieldDecorator>;
};

export default HtmlFieldLayoutWithTags;
